import { Button, Rate } from "antd";
import TextArea from "antd/es/input/TextArea";
import { useState } from "react";
import { useCourseReviewMutation } from "../../../../app/features/courses/courses.api";
import CustomModal from "../../../../components/CustomModal";
import { toast } from "../../../../lib/toast";

type Props = {
  open: boolean;
  handleClose: () => void;
  courseId: string;
  setIsCompleted?: (val: boolean) => void;
};

export default function CourseRatingModal({
  open,
  handleClose,
  courseId,
  setIsCompleted,
}: Props) {
  const [rating, setRating] = useState(5);
  const [review, setReview] = useState("");
  const [submitReview, { isLoading }] = useCourseReviewMutation();

  const handleSubmit = async () => {
    if (!rating) {
      return toast("error", "রেটিং দিন");
    }
    // if (!review) {
    //   return toast("error", "রিভিউ লিখুন");
    // }

    const data = {
      rating,
      comment: review,
    };

    try {
      await submitReview({
        courseId,
        ...data,
      }).unwrap();

      setIsCompleted?.(true);
      handleClose();
      toast("success", "রেটিং সফলভাবে জমা দেওয়া হয়েছে");
    } catch (error) {
      toast("error", "রেটিং জমা দিতে ব্যর্থ হয়েছে");
    }
  };

  return (
    <CustomModal
      handleClose={handleClose}
      title="কোর্সের সম্বন্ধে আপনার মতামত দিন"
      open={open}
      footer={[
        <Button
          key="cancel"
          className="disabled:bg-gray-100"
          onClick={handleClose}
          disabled={isLoading}
        >
          বাতিল করুন
        </Button>,
        <Button
          key="capture"
          type="primary"
          onClick={handleSubmit}
          loading={isLoading}
        >
          রিভিউ সাবমিট করুন
        </Button>,
      ]}
      width={600}
      centered
    >
      <Rate
        value={rating}
        onChange={(val) => setRating(val)}
        count={5}
        className="custom-rate"
      />
      <TextArea
        placeholder="আপনার মতামত লিখুন"
        className="mt-4 font-primary"
        rows={4}
        value={review}
        onChange={(e) => setReview(e.target.value)}
      />
    </CustomModal>
  );
}
